/* global process */
const config = {
  apiBaseUrl: process.env.REACT_APP_API_URL,
  countriesBaseUrl: process.env.REACT_APP_API_COUNTRIES,
  minProductPrice: process.env.REACT_APP_MIN_PAYMENT_AMOUNT ? parseInt(process.env.REACT_APP_MIN_PAYMENT_AMOUNT, 10) : 5000,
  siteKeyRecaptcha: process.env.REACT_APP_SITE_KEY_RECAPTCHA,
};

export default config;
